module.exports = __webpack_public_path__ + "img/407.6a07330b.jpg";